import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TourCard from "./TourCard";

const Cardprice = () => {
  const navigate = useNavigate();

  const tourData = [
    {
      id: "six",
      title: "Spiti Winter Expedition",
      places: "Manali • Kaza • Dhanker • Tabo • Rohtang Pass • Nagar Castle",
      price: "₹ 41,499/-",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-YGrzNfqfDvNz1kPUtWBzIAEcJ-o7dD2I2Q&s",
      rating: 4.7
    },

    {
      id: "five",
      title: "Manali-Kargil Via Zanskar",
      places: "Manali • Sinku La • Drang-Drung Glacier • Kargil • Suru Valley",
      price: "₹ 34,999/-",
      image: "https://www.kullumanalitrips.com/images/manali-tour-package-images/manali-tour-package-1383.jpg",
      rating: 4.4
    },
    {
      id: "three",
      title: "Ladakh - The Cold Desert",
      places: "Leh • Nubra • Pangong • Khardung La",
      price: "₹ 9,000/-",
      image: "https://media.traveljunky.in/website-assets/sub-navigation/ladakh-tour-packages/68ba9eb95025c.webp",
      rating: 4.6
    },
    {
      id: "seven",
      title: "Kashmir",
      places: "Srinagar • Gulmarg • Pahalgam",
      price: "₹ 9,000/-",
      image: "https://travelsolution.dukekashmirtravels.com/User_Files/image/blog/kashmir%20dos%20and%20dont.jpg",
      rating: 4.9
    }
  ];

  const enrichTour = (tour, index) => {
    const durations = ["5D / 4N", "6D / 5N", "7D / 6N"];
    const tags = ["Group Tour", "Bestseller", "Limited Offer"];

    return {
      ...tour,
      duration: durations[index % durations.length],
      tag: tags[index % tags.length],
      oldPrice: parseInt(tour.price.replace(/[₹,/-]/g, "")) + 4000,
      discountEndsIn: "1d 3h 42m",
    };
  };

  return (
    <Box sx={{ px: 2 }}>
      <Typography variant="h3" fontWeight={800} mb={3} mt={3}>
        Top Destinations Loved By Clients
      </Typography>

      <Grid container spacing={3}>
        {tourData.map((tour, index) => (
          <Grid item xs={12} sm={6} md={3} key={tour.id}>
            <TourCard
              tour={tour}
              index={index}
              onViewDetails={() =>
                navigate("/tourdetails", {
                  state: enrichTour(tour, index) // ✅ SAME AS JK PAGE
                })
              }
              onEnquire={() => navigate("/booking")}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Cardprice;
